import { parseApiDateOnly } from "@/common/helpers/date-input";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Whole calendar days between an API due date (`YYYY-MM-DD` or ISO datetime) and the browser's local date.
 * Compares day boundaries (not timestamps) so it agrees with the server-side `referenceDate` aging.
 */
export function getDaysOverdue(dueDate: string, today = new Date()): number {
  const due = parseApiDateOnly(dueDate);
  if (!due) return 0;

  const dueDay = Date.UTC(due.getFullYear(), due.getMonth(), due.getDate());
  const todayDay = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());

  return Math.max(0, Math.round((todayDay - dueDay) / MS_PER_DAY));
}
